<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <label v-if="label" :for="name">{{ label }}</label>
    <input type="number"
           v-bind:value="value"
           v-on:input="updateValue($event.target.value)"
           v-bind:name="name"
           v-bind:step="step"
           v-bind:min="min"
           v-bind:max="max"
           v-bind:required="required"
           v-bind:placeholder="placeholder"
           v-on:keyup="checkMax()"
           class="form-control"
    >
    <span v-if="error"
          class="help-block"
          v-html="error"
    ></span>
  </div>
</template>

<script>
  export default{
    name: 'InputNumber',
    props: ['name', 'value', 'step', 'min', 'max', 'required', 'label', 'placeholder', 'error'],
    methods: {
      updateValue (value) {
        this.$emit('input', value)
      },
      checkMax () {
        if (this.value > this.max) {
          this.$emit('input', this.max)
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// InputNumber.vue?7563b4d2